import React from 'react';
import { Box, Divider, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Subtitle2 from '../../common/typographys/Subtitle2';
import CardBlock from '../../common/forms/CardBlock';
import Body1 from '../../common/typographys/Body1';
import isEmpty from '../../../utils/isEmpty';
import formatMoney from '../../../utils/formatMoney';

const useStyles = makeStyles(() => ({
  label: {
    marginBottom: '8px',
  },
  entityItem: {
    marginBottom: '10px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  budgetItem: {
    marginBottom: '10px',
    '&:first-child': {
      marginBottom: 0,
    },
  },
}));

const ProposalEntities = ({ entities, multipleBudgets }) => {
  const classes = useStyles();

  if (!entities || entities.length === 0) return null;

  return (
    <>
      <Subtitle2 tertiary>Entidades</Subtitle2>

      <CardBlock label="" singlePadding smallMargin>
        {entities.map((entity, idx) => (
          <React.Fragment key={entity.id || idx}>
            <Box className={classes.entityItem}>
              <Subtitle2 color="initial" className={classes.marginLabel}>
                {entity.name}
              </Subtitle2>

              {multipleBudgets ? (
                <>
                  {entity.budgets && entity.budgets.length > 0 ? (
                    <>
                      <Box height="12px" />
                      {/* <Subtitle2 tertiary className={classes.label}>Compromissos</Subtitle2> */}
                      {entity.budgets.map((budget, budgetIdx) => (
                        <Box key={budget.id || budgetIdx} className={classes.budgetItem}>
                          <Subtitle2 tertiary className={classes.label}>Número do compromisso</Subtitle2>
                          <Body1>{budget.budgetNumber || budget.budget_number || 'N/D'}</Body1>

                          <Box height="8px" />
                          <Subtitle2 tertiary className={classes.label}>Valor do apoio</Subtitle2>
                          <Body1>
                            {!isEmpty(budget.amount) ? formatMoney(budget.amount) : 'N/D'}
                          </Body1>

                          <Box height="8px" />
                          <Subtitle2 tertiary className={classes.label}>Intervenção</Subtitle2>
                          <Body1>{budget.intervention || 'N/D'}</Body1>
                        </Box>
                      ))}
                    </>
                  ) : (
                    <Body1>Sem compromissos</Body1>
                  )}
                </>
              ) : (
                <>
                  {entity.has_budget ? (
                    <>
                      <Box height="12px" />
                      <Subtitle2 tertiary className={classes.label}>Número do compromisso</Subtitle2>
                      <Body1>{entity.budget_number || 'N/D'}</Body1>

                      <Box height="12px" />
                      <Subtitle2 tertiary className={classes.label}>Valor do apoio</Subtitle2>
                      <Body1>
                        {!isEmpty(entity.amount) ? formatMoney(entity.amount) : 'N/D'}
                      </Body1>
                    </>
                  ) : (
                    <>
                      <Box height="12px" />
                      <Body1>Sem compromiso</Body1>
                    </>
                  )}
                </>
              )}


              {/* {entity.has_budget ? (
                <>
                  <Box height="12px" />
                  <Subtitle2 tertiary className={classes.label}>Número do compromisso</Subtitle2>
                  <Body1>{entity.budget_number || 'N/D'}</Body1>

                  <Box height="12px" />
                  <Subtitle2 tertiary className={classes.label}>Valor do apoio</Subtitle2>
                  <Body1>
                    {!isEmpty(entity.amount) ? formatMoney(entity.amount) : 'N/D'}
                  </Body1>
                </>
              ) : (
                <>
                  <Box height="12px" />
                  <Subtitle2 tertiary className={classes.label}>Número do compromisso</Subtitle2>
                  <Body1>N/D</Body1>

                  <Box height="12px" />
                  <Subtitle2 tertiary className={classes.label}>Valor do apoio</Subtitle2>
                  <Body1>N/D</Body1>
                </>
              )} */}

            </Box>

            {idx < entities.length - 1 && <Divider style={{ marginBottom: '12px', opacity: '0.5' }} />}
          </React.Fragment>
        ))}
      </CardBlock>
    </>
  );
};

ProposalEntities.propTypes = {
  // entities: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  //     name: PropTypes.string.isRequired,
  //     has_budget: PropTypes.bool,
  //     budget_number: PropTypes.string,
  //     amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  //   })
  // ),
  entities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string.isRequired,
      has_budget: PropTypes.bool,
      budget_number: PropTypes.string,
      amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      budgets: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          budgetNumber: PropTypes.string,
          budget_number: PropTypes.string,
          amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          intervention: PropTypes.oneOfType([PropTypes.string, PropTypes.string]),
        })
      ),
    })
  ),
  multipleBudgets: PropTypes.bool,
};

ProposalEntities.defaultProps = {
  entities: [],
  multipleBudgets: false,
};

export default React.memo(ProposalEntities);
